import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { slackAuthLinkGetAsyncSlice } from './get';

export const slackReducers = combineReducers({
	get: slackAuthLinkGetAsyncSlice.asyncReducers
});

export const slackWatchers = combineAllWatchers([
	slackAuthLinkGetAsyncSlice.asyncWatchers
]);
